import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Api } from '../../providers';
import { HttpClient } from '@angular/common/http';

@IonicPage()
@Component({
  selector: 'page-inicio',
  templateUrl: 'inicio.html'
})
export class InicioPage {
  public sucursales: Array<any>;
  public promocionales: Array<any>;
  banners: Array<any> = [];
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private _api: Api,
    private _http: HttpClient
  ) {}

  ionViewDidLoad() {
    this._api.get('banners').subscribe((banners: any) => {
      this.banners = banners.sort((a,b) => a.orden - b.orden);
      console.log(banners);
      console.log(this.banners);
      this._api.subscribeCollection('banners', this.banners);
    });
    this._api.get('sucursales').subscribe((sucursales: any) => {
      this.sucursales = sucursales;
    });
    this._api.get('promocionales').subscribe((promocionales: any) => {
      if (promocionales)
        this.promocionales = promocionales.sort((a: any, b: any) => {
          return a.orden - b.orden;
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/inicio/inicio.ts